import {css} from "../../admin/script/libs/lit.dist.js";

// language=CSS
export default css`
    :host {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        pointer-events: none;

    }

    :host(.ribbon-sm) {
        --padding: 0;
        --font-size: 0.55rem;
    }
    
    :host(.fw-bold) {
        font-weight: bold;
    }
    
    .pk-corner-ribbon {
        position: absolute;
        top: 0;
        right: 0;
        background: var(--background, var(--bs-primary));
        width: var(--width);
        transform-origin: 0 100%;
        color: var(--color, #fff);
        font-size: var(--font-size, 0.6rem);
        padding: var(--padding, 0.1rem) calc(1rem + var(--offset, 0rem));
        rotate: 45deg;
        translate: calc((1 - cos(45deg)) * 100%) -100%;
    }
    
`;
